import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

import { RequestBodyModel } from "../../models";
import { Log } from "../log.helpers";
import { getAccessToken } from "./auth.helpers";
import { refreshAccessToken } from "./token-refresh.helpers";

export const retryWithTokenRefresh = async <T>(
  config: AxiosRequestConfig<RequestBodyModel>,
): Promise<AxiosResponse<T>> => {
  await refreshAccessToken();

  const token = getAccessToken();

  if (config.headers) {
    if (token) {
      Log.debug("Retrying request with refreshed token");
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
  }

  return axios(config);
};
